import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostListener,
    Input,
    ViewChild,
} from '@angular/core';
import { BazisInputDefaultComponent } from '@bazis/form/components/base/inputs/input-default.component';
import { map, tap } from 'rxjs/operators';
import { latinizeStr } from '@bazis/utils';
import { shareReplay, Subject } from 'rxjs';
import { SHARE_REPLAY_SETTINGS } from '@app/configuration.service';

@Component({
    selector: 'app-ghost-input-default',
    templateUrl: './ghost-input-default.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GhostInputDefaultComponent extends BazisInputDefaultComponent {
    @HostListener('keydown', ['$event'])
    onKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.save();
            if (this.ghostInputEl) {
                this.ghostInputEl.nativeElement.blur(event);
            }
        }
        if (event.key === 'Escape') {
            this.cancel();
            if (this.ghostInputEl) {
                this.ghostInputEl.nativeElement.blur(event);
            }
        }
    }

    @ViewChild('ghostInput') ghostInputEl: ElementRef;

    @Input()
    canSaveEmpty: boolean = false;

    save$ = new Subject();

    valueChanges$ = this.save$.pipe(
        map(() => this.field.value),
        tap((value) => {
            if (this.formatter || (this.forceLatin && value)) {
                let newValue = this.forceLatin
                    ? latinizeStr(value.toUpperCase())
                    : this.formatter(value);
                if (value !== newValue) {
                    this.field.setValue(newValue);
                    this.save$.next(true);
                    return;
                }
            }
            this.onChange(value);
        }),
        shareReplay(SHARE_REPLAY_SETTINGS),
    );

    constWidthCh = 32;

    savedEmpty = false;

    lastValue;

    isViewTypeReadonly = false;

    public writeValue(value: any): void {
        super.writeValue(value);

        this.lastValue = value;

        this.isViewTypeReadonly = !!value && (!this.emptyValue || value !== this.emptyValue);
    }

    extendOnInit() {
        this.isRightIconClickable = this.isLeftIconClickable ? false : true;
        if (this.ngControl.control.value) this.isViewTypeReadonly = true;
    }

    save() {
        this.save$.next(true);
        this.savedEmpty = !this.field.value;
        if (this.field.value) {
            this.isViewTypeReadonly = true;
        }
    }

    cancel() {
        const currentValue = this.field.value;
        this.field.setValue(this.lastValue);
        this.save();
        this.lastValue = currentValue;
    }

    onClear(e) {
        if (this.canEraserShow) {
            this.erased.emit(e);
        }
        this.field.setValue('');
        this.save();
    }

    focusField(e) {
        super.focusField(e);
        this.isViewTypeReadonly = false;
    }

    blurField(e) {
        super.blurField(e);
        this.isViewTypeReadonly = true;
    }
}
